/* eslint-disable */

import * as XLSX from 'xlsx'
import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { CATEGORY_LIST, EXPENSE_LIST } from "../../urls";
import { useLoad } from "../../hooks/request";
import { useQueryParams } from "../../hooks/queryString";
import DateFilter from "../../components/common/DateFilter";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Table from "../../components/common/Table";
import Layout from "../../components/Layout";
import { Link, NavLink, useParams } from "react-router-dom";
import FilterSelect from "../../components/common/FilterSelect";
import ExpensesColumn from "../earnings/Column";
import ExpenseCreate from "../earnings/expense-create";
import Search from '../../components/Search'
import { isEmpty } from "lodash";
import queryString from "querystring";


export default function RentDetail() {
    const { marketId } = useParams()
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})
    const searchParam = useQueryParams()
    const employeeDetail = useLoad({ url: '/main/market/{id}'.replace('{id}', marketId) })
    const item = employeeDetail.response ? employeeDetail.response : {}
    const category = useLoad({ url: CATEGORY_LIST, params: { page, ...searchParam, size: 1000 } }, [page, searchParam])

    const expense = useLoad(
        {
            url: EXPENSE_LIST,
            params: { page, ...params, ...searchParam, market: marketId },
        },
        [searchParam, page, params],
    )

    const { response: categoryResponse } = useLoad({ url: CATEGORY_LIST, params: { size: 1000 } })
    const categoryItems = categoryResponse ? categoryResponse.results : []
    const productList = expense.response ? expense.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<ExpenseCreate marketId={marketId} employeeId={marketId} category={category} expenseReport={expense} onCancel={() => setShowCreateModal()} />, styles.modal)

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    console.log(productList[0])

    const exportToExcel = (response) => {
        const headers = [
            { text: 'ID', key: 'id' },
            { text: 'Статус', key: 'status' },
            { text: 'Категория', key: 'category' },
            { text: 'Масул Ходим', key: 'assigned' },
            { text: 'Сумма', key: 'amount' },
            { text: 'Изоҳ', key: 'comment' },
            { text: 'Сана', key: 'createdAt' },
        ]

        const data = response.results.map((item) => ({
            id: item.id,
            status: item.status === 'expenses' ? 'Чиқим' : 'Кирим',
            category: item.selectCategory?.name || '',
            subcategory: item.selectSubCategory?.name || '',
            assigned: item.selectAssigned?.username || '',
            amount: parseInt(item.amount, 10), // Ensure amount is an integer,
            comment: item.comment || '',
            createdAt: new Date(item.createdAt).toLocaleDateString('en-GB'),
        }))

        const totalRow = {
            id: '',
            status: '',
            category: '',
            assigned: 'ЖАМИ КИРИМ',
            amount: parseInt(response.totalIncomeAmount, 10),
            comment: '',
            createdAt: '',
        }
        const expensesRow = {
            id: '',
            status: '',
            category: '',
            assigned: 'ЖАМИ ЧИҚИМ',
            amount: parseInt(response.totalExpensesAmount, 10),
            comment: '',
            createdAt: '',
        }
        const balanceRow = {
            id: '',
            status: '',
            category: '',
            assigned: 'Баланс',
            amount: parseInt(response.balance, 10),
            comment: '',
            createdAt: '',
        }

        const rows = [headers.map((header) => header.text), ...data.map((item) => headers.map((header) => item[header.key])), ['', '', '', '', '', '', '', ''], Object.values(totalRow), Object.values(expensesRow), Object.values(balanceRow)]

        const ws = XLSX.utils.aoa_to_sheet(rows)

        // Apply border styles with 2px black borders
        const range = XLSX.utils.decode_range(ws['!ref'])
        const borderStyle = {
            top: { style: 'medium', color: { rgb: '000000' } },
            bottom: { style: 'medium', color: { rgb: '000000' } },
            left: { style: 'medium', color: { rgb: '000000' } },
            right: { style: 'medium', color: { rgb: '000000' } },
        }

        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C })
                if (!ws[cellAddress]) ws[cellAddress] = { v: '' } // Create empty cells if needed
                ws[cellAddress].s = { border: borderStyle }
            }
        }

        // Set column widths
        const colWidths = headers.map((header, index) => {
            const maxLength = Math.max(...rows.map((row) => (row[index] ? row[index].toString().length : 0)))
            return { wch: maxLength + 2 }
        })
        ws['!cols'] = colWidths

        // Create workbook and append sheet
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Молия Маълумотлари')

        // Save to file
        XLSX.writeFile(wb, 'МолияМаълумотлари.xlsx')
    }

    function onSearch(query) {
        const search = !isEmpty(query) ? query : undefined
        history.push(`?${queryString.stringify({ ...params, search })}`)
    }

    return (
        <Layout showCreateModal={showCreateModal}>
            {/* Header Section */}
            <div className="is-flex is-justify-content-space-between is-align-items-center mb-3" style={{ flexWrap: 'wrap', gap: '12px' }}>
                {/* Back Button and Item Name */}
                <div className="is-flex is-align-items-center" style={{ gap: '12px', flexWrap: 'wrap' }}>
                    <Link className="has-text-link button is-white is-size-4" to="/rent">
                        <i className="icon ion-md-arrow-back is-size-4" />
                    </Link>
                    <span className="is-size-4 has-text-weight-semibold">{item.name}</span>
                </div>

                {/* Filters and Buttons */}
                <div className="is-flex" style={{ gap: '12px', alignItems: 'center', flexWrap: 'wrap' }}>
                    <NavLink to={`/rent/${marketId}/utility-bills`}>
                        <Button text="Камунал тўловлари" className="button is-info is-outlined" />
                    </NavLink>
                    <Button text="Excel" className="button is-success is-outlined" onClick={() => exportToExcel(expense.response)} />
                    <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal} />
                </div>
            </div>

            {/* Filters and Actions */}

            {/* Income, Expense, and Balance Summary */}
            <div className="columns has-text-centered mb-4">
                <div className="column">
                    <div className="box has-background-success-light">
                        <p className="title is-5 has-text-success">💰 Кирим</p>
                        <p className="subtitle is-6">{format(expense.response ? expense.response.totalIncomeAmount : 0)} UZS</p>
                    </div>
                </div>
                <div className="column">
                    <div className="box has-background-danger-light">
                        <p className="title is-5 has-text-danger">💸 Чиқим</p>
                        <p className="subtitle is-6">{format(expense.response ? expense.response.totalExpensesAmount : 0)} UZS</p>
                    </div>
                </div>
                <div className="column">
                    <div className="box has-background-warning-light">
                        <p className="title is-5 has-text-warning">⚠️ Баланс</p>
                        <p className="subtitle is-6">{format(expense.response ? expense.response.balance : 0)} UZS</p>
                    </div>
                </div>
            </div>

            <div className="is-flex is-justify-content-space-between is-align-items-center mb-3" style={{ flexWrap: 'wrap', gap: '12px' }}>
                {/* Search Input */}
                <div style={{ flex: '1 1 300px', minWidth: '250px' }}>
                    <Search onSearch={onSearch} />
                </div>

                {/* Category Filters */}
                <div
                    className="is-flex"
                    style={{
                        flex: '2 1 500px',
                        flexWrap: 'wrap',
                        gap: '8px',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    }}
                >
                    <FilterSelect setSearchParams={setParams} placeholder="Категория" name="category" options={categoryItems.filter((item) => item.parent === null)} />
                    <DateFilter name="start_date" />
                    <DateFilter name="end_date" />
                </div>
            </div>

            {/* Expenses Table */}
            <div className="mt-4 mb-4">
                <Table
                    loading={expense.loading}
                    items={productList}
                    columns={{
                        index: '№',
                        category: 'Категория',
                        subcategory: 'Масул Ходим',
                        status: 'Статус',
                        amount: 'Сумма',
                        date: 'Сана',
                        paymentType: 'Тўлов тури',
                        note: 'Эслатма',
                        buttons: '',
                    }}
                    totalCount={expense.response?.count || 0}
                    activePage={page}
                    onPageChange={setPage}
                    renderItem={(item, index) => <ExpensesColumn expenseReport={expense} index={index} key={item.id} item={item} />}
                />
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
